import React, { useState } from "react";
import { Row, Col, Typography, QRCode } from "antd";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const PaymentQR = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Row gutter={[20, 20]}>
      <Col align="center" xl={24} lg={24} md={24} xs={24}>
        <Typography.Title level={4}>
          Thanh toán qua số tài khoản
        </Typography.Title>
        <Typography.Text type="secondary">
          File chưa được mở khoá, xin vui lòng thanh toán để xem nội dung chi
          tiết
        </Typography.Text>
      </Col>
      <Col align="center" xl={24} lg={24} md={24} xs={24}>
        <QRCode size={200} value="Nguyễn Văn Toàn" />
      </Col>
    </Row>
  );
};
export default PaymentQR;
